/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Transfer_Supplier_Rib_InvalidInputs */

const fr_api_transfer_supplier_rib_invalid = /** @type {(inputs: Api_Transfer_Supplier_Rib_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renseignez un RIB tunisien de 20 chiffres dans la fiche du prestataire avant d’émettre l’ordre.`)
};

const en_api_transfer_supplier_rib_invalid = /** @type {(inputs: Api_Transfer_Supplier_Rib_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a 20-digit Tunisian RIB in the contractor’s record before issuing the order.`)
};

/**
* | output |
* | --- |
* | "Enter a 20-digit Tunisian RIB in the contractor’s record before issuing the order." |
*
* @param {Api_Transfer_Supplier_Rib_InvalidInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_transfer_supplier_rib_invalid = /** @type {((inputs?: Api_Transfer_Supplier_Rib_InvalidInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Transfer_Supplier_Rib_InvalidInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_transfer_supplier_rib_invalid(inputs)
	return fr_api_transfer_supplier_rib_invalid(inputs)
});